import { Tag } from '@servicetitan/design-system';

interface SearchResultBadgeProps {
  count: number;
}

const SearchResultBadge = ({ count }: SearchResultBadgeProps) => {
  const showBadge = count > 0;

  if (!showBadge) {
    return null;
  }

  return (
    <Tag className='cursor-pointer' compact badge size={2}>{`+${count}`}</Tag>
  );
};

export default SearchResultBadge;
